var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VTooltip',{attrs:{"placement":"bottom"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},[_c('template',{slot:"popper"},[(_vm.hasValueSlot)?_vm._t("value"):_c('our-label',{attrs:{"value":_vm.text,"dark":""}})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }